import React from "react";

import { IImagePreview, Image } from "../../../graphql/queries/gallery.js";
import MediaItem from "../../gallery/_common/MediaItem.js";
import { EngagementInfo } from "../../../graphql/queries/_common.js";
import ShareButtons from "../../common/ShareButtons.js";
import GameSummaryBadge from "./GameSummaryBadge.js";
import {
    mediaItemContainer,
    navButton,
    pageTitle,
    quizText,
    topicTags,
} from "../quiz/common.css.js";
import MarkdownRenderer from "../../common/MarkdownRenderer.js";
import { Topic } from "../../../graphql/queries/topics.js";
import TopicTags from "../../common/TopicTags.js";
import { GameTypename } from "../../../graphql/queries/games/_common.js";

interface Props {
    gameId: string;
    typename: GameTypename;
    slug: string | null;
    title: string;
    text: string;
    image: Image | IImagePreview | null;
    startButtonText: string;
    pagePath: string;
    onStartHandler: () => void;
    engagementInfo: EngagementInfo;
    usersCount: number | null;
    questionsNumber?: number;
    avgScore?: number | null;
    topics: (Topic | null)[];
}

const GameIntro: React.FC<Props> = ({
    gameId,
    typename,
    slug,
    title,
    text,
    image,
    startButtonText,
    pagePath,
    onStartHandler,
    engagementInfo,
    usersCount,
    questionsNumber,
    avgScore,
    topics,
}) => {
    return (
        <>
            <h1 className={pageTitle}>{title}</h1>
            <TopicTags
                topics={topics}
                place="game_intro"
                cpath={pagePath}
                className={topicTags}
            />
            <MarkdownRenderer className={quizText} source={text} />
            <div className={mediaItemContainer}>
                <MediaItem
                    mediaItem={image}
                    showPlaceholder={false}
                    srcSetSizes={{
                        tablet: 614,
                    }}
                />
                <GameSummaryBadge
                    isIntro={true}
                    questionsNumber={questionsNumber}
                    avgScore={avgScore}
                    usersCount={usersCount}
                />
            </div>

            <button className={navButton} onClick={onStartHandler}>
                {startButtonText}
            </button>
            <ShareButtons
                pageTitle={title}
                position="quiz-intro" // TODO: check and replace with "game-intro" ?
                typename={typename}
                pagePath={pagePath}
                engagementInfo={engagementInfo}
                medium={gameId}
                slug={slug}
            />
        </>
    );
};

export default GameIntro;
